import AlertDialog from 'ub/ui/alert-dialog';
import React from 'react';

const ActionBar = ({showSaveAsNewVariantButton, onSaveNewVariant, onOverwrite}) => {
  const overwriteClass = showSaveAsNewVariantButton ?
    "save button modal-button overwrite-changes-btn" :
    "save button modal-button overwrite-changes-btn action";

  const OverwriteButton = () => (
    <a className={overwriteClass} onClick={onOverwrite}>
      <span>Overwrite Changes</span>
    </a>
  );

  const SaveAsNewVariantButton = () => (
    <a className="save button modal-button action push-left" onClick={onSaveNewVariant}>
      <span>Save as new Variant</span>
    </a>
  );

  return (
    <div className="variant-changes-container push-left">
      <OverwriteButton />
      {showSaveAsNewVariantButton ? <SaveAsNewVariantButton /> : undefined}
    </div>
  );
};

export default function saveConflictAlert(
  pageSupportsMultipleVariants,
  onClose,
  onSaveNewVariant,
  onOverwrite
) {
  const message = pageSupportsMultipleVariants ?
    `This content has been modified elsewhere since you started working on it. Would you
      like to overwrite the other changes with this version or save this as a new variant?` :
    `This content has been modified elsewhere since you started working on it. Would you
      like to overwrite the other changes with this version?`;

  return new AlertDialog({
    title: 'Your page has been modified elsewhere',
    closeX: true,
    icon: 'error',
    onClose,
    message,
    containerClass: 'modal-content-container',
    actionBar: (
      <ActionBar
        showSaveAsNewVariantButton={pageSupportsMultipleVariants}
        onSaveNewVariant={onSaveNewVariant}
        onOverwrite={onOverwrite}
      />
    ),
  });
}

ActionBar.propTypes = {
  onSaveNewVariant: React.PropTypes.func,
  onOverwrite: React.PropTypes.func,
  showSaveAsNewVariantButton: React.PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/ui/alert-dialog/save-conflict.jsx